// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"603":"d802f4cb","641":"bc1776da"}[chunkId] + ".chunk.css";
};